export default (axios, checkHeaders) => ({
  getList (data = {}) {
    return axios.get('/modules', { params: data.filters || {} })
  },
  postOne (data = {}) {
    return axios.post('/module', data.body, { params: data.filters || {} })
  },
  getOne (data = {}) {
    return axios.get('/module/' + data.id, { params: data.filters || {} })
  },
  patchOne (data = {}) {
    return axios.patch('/module/' + data.id, data.body, { params: data.filters || {} })
  },
  deleteOne (data = {}) {
    return axios.delete('/module/' + data.id, { params: data.filters || {} })
  }
})
